import { buildTestIds } from "application";
import * as InstallmentSub from "./installment.styles";
import {
  InstallmentContainerProps,
  InstallmentProps,
} from "./installment.types";

export const Installment = ({
  hasFees = false,
  price = 0,
  quantity = 1,
  totalPrice = 0,
  isHighlighted = false,
}: InstallmentProps & InstallmentContainerProps) => {
  const installmentPrice = price.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });

  const totalInstallmentPrice = totalPrice.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });

  const feeText = hasFees ? "com juros" : "sem juros";

  return (
    <InstallmentSub.Container
      isHighlighted={isHighlighted}
      {...buildTestIds("installment-container")}
    >
      <InstallmentSub.InfoContainer
        {...buildTestIds("installment-info-container")}
      >
        <InstallmentSub.InstallmentPrice {...buildTestIds("installment-price")}>
          {`${quantity}x de ${installmentPrice}`}
        </InstallmentSub.InstallmentPrice>
        <InstallmentSub.FeeLegend {...buildTestIds("installment-fee-legend")}>
          {feeText}
        </InstallmentSub.FeeLegend>
      </InstallmentSub.InfoContainer>
      <InstallmentSub.SpotTitle {...buildTestIds("installment-spot-title")}>
        {totalInstallmentPrice}
      </InstallmentSub.SpotTitle>
    </InstallmentSub.Container>
  );
};
